import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { DynamicFeatureFlagService } from 'shared/services';

import { ADMIN_HOME_PLATFORM_USERS, ADMIN_PLATFORM_FEATURE_FLAG } from '../constants/admin-routes.constants';

/** When v2 admin is enabled, `/dashboard` redirects to the platform users home. */
export const adminDashboardRedirectGuard: CanActivateFn = () => {
    const dynamicFeatureFlagService = inject(DynamicFeatureFlagService);
    const router = inject(Router);

    return dynamicFeatureFlagService.isFeatureEnabled$(ADMIN_PLATFORM_FEATURE_FLAG).pipe(
        take(1),
        map((enabled) => (enabled ? router.parseUrl(ADMIN_HOME_PLATFORM_USERS) : true))
    );
};
